import { Button } from '@sketch/components'
import styled, { css } from 'styled-components'

import { COMPARE_TINT } from '../../compareTint'
import { SPLIT_FRACTION_VAR } from '../../useSplitFraction'

/** Three buttons, each its own control: a shared ground would read as a picker. */
export const Actions = styled.div`
  display: flex;
  align-items: center;
  margin-top: 4px;

  /* The footer as a whole takes no pointer events, so these ask for them back. */
  pointer-events: auto;
`

export const Action = styled(Button).attrs({ variant: 'tertiary', size: '24' })`
  /* Tighter than the scale goes: these sit on the canvas, not in a panel */
  padding: 3px 6px; /* stylelint-disable-line scales/space */
  min-height: auto;
`

export const SplitButton = styled(Action)<{ $sourceOnRight?: boolean }>`
  ${({ $active, $sourceOnRight, theme }) => {
    if (!$active) return undefined

    /*
    The two versions in the order the canvas has them: the compared one on
    whichever side it is drawn, so the button reads as a small picture of the
    overlay rather than a mirror of it.

    The line comes from the element's own inline style, so moving it changes a
    number rather than minting a class per position.
    */
    const line = `var(${SPLIT_FRACTION_VAR}, 50%)`
    const onScreen = theme.colors.sketch.A
    const compared = COMPARE_TINT.strong

    const filled = $sourceOnRight
      ? `linear-gradient(to right, ${onScreen} 0 ${line}, ${compared} ${line})`
      : `linear-gradient(to right, ${compared} 0 ${line}, ${onScreen} ${line})`

    return css`
      color: ${theme.colors.foreground.primary.A};
      background: ${filled};

      border: none;

      :hover {
        color: ${theme.colors.foreground.primary.B};
      }
    `
  }}
`
